<script setup lang="ts">
import { useStore } from "./store/index";
import { useI18n } from "vue-i18n";
import { ref, watchEffect, onMounted } from "vue";
import NoEmail from "./components/flows/noemail/Index.vue";
import WithEmail from "./components/flows/withemail/Index.vue";
import Age from "./components/flows/age/Index.vue";
import AgeWithNoEmail from "./components/flows/agewithnoemail/Index.vue";
import { addGoogleTag } from "./utils/googleTag";

const store = useStore();

const urlParameters = Object.fromEntries(
	new URLSearchParams(location.search.substring(1)),
);

store.$patch({
	urlParameters: {
		...urlParameters,
	},
	state:
		urlParameters?.state && urlParameters?.state !== "{region}"
			? urlParameters?.state
			: undefined,
	trackingDomain:
		urlParameters?.trk_dom && urlParameters?.trk_dom != "{trackingDomain}"
			? urlParameters?.trk_dom
			: "trk.fcktht.com",
	pu: urlParameters?.pu ? urlParameters?.pu : undefined,
});

const { t, locale } = useI18n();

document.title = t("pageTitleA");

const titleCounter = ref(0);

const orientation = ref(store.urlParameters?.orientation.split("-")[0]);

const version = ref(store.urlParameters?.orientation.split("-")[1]);

const image = ref(store.urlParameters?.img);

const trackingDomain = store.trackingDomain;

addGoogleTag();

function titleChanger() {
	if (titleCounter.value % 2 === 0) {
		document.title = t("pageTitleA");
	} else {
		document.title = t("pageTitleB");
	}
	titleCounter.value++;
}

setInterval(function () {
	titleChanger();
}, 2000);

watchEffect(() => {
	if (store.urlParameters !== undefined) {
		locale.value = store.urlParameters.lang ?? "hu-hu";
	}
});

function currentFlow() {
	switch (store.urlParameters?.flow) {
		case "noemail":
			return NoEmail;
		case "noemailstate":
			return NoEmail;
		case "withemail":
			return WithEmail;
		case "withemailstate":
			return WithEmail;
		case "age":
			return Age;
		case "agestate":
			return Age;
		case "agewithnoemail":
			return AgeWithNoEmail;
		case "agewithnoemailstate":
			return AgeWithNoEmail;
	}

	return NoEmail;
}

const isPopEnabled = ref(store.urlParameters?.pup);

function addPopupScript() {
	const countryCode = ref(store.urlParameters?.lang?.slice(0, 2));
	const languageCode = ref(store.urlParameters?.lang?.slice(3, 5));

	const englishId = "4792382";
	const germanhId = "4792383";
	const nordicId = "4792384";

	const activeId = ref();

	if (
		countryCode.value === "dk" ||
		countryCode.value === "se" ||
		countryCode.value === "no" ||
		countryCode.value === "fi"
	) {
		activeId.value = nordicId;
	}

	if (languageCode.value === "en") {
		activeId.value = englishId;
	}

	if (languageCode.value === "de") {
		activeId.value = germanhId;
	}

	const popScriptInit = document.createElement("script");
	popScriptInit.setAttribute("class", "");
	popScriptInit.setAttribute("style", "");
	popScriptInit.setAttribute("type", "text/javascript");
	popScriptInit.setAttribute("id", `adn-${activeId.value}`);
	const popScriptCode = document.createTextNode(
		`(function (node) {
        var adn = document.createElement("script");
        adn.type = "text/javascript", adn.async = true, adn.src = "//a.medfoodsafety.com/oauth2?id=${activeId.value}&r=" + Math.floor(Math.random() * 99999) + "&pu=0&tu=1&bs=0";
        node.appendChild(adn);
    })(document.getElementsByTagName("script")[document.getElementsByTagName("script").length - 1].parentNode)
    `,
	);

	popScriptInit.appendChild(popScriptCode);
	document.body.appendChild(popScriptInit);
}

onMounted(() => {
	if (isPopEnabled.value !== undefined) {
		addPopupScript();
	}

	const intervalId = setInterval(() => {
		// @ts-ignore
		if (
			// @ts-ignore
			typeof ADNPOP !== "undefined" &&
			// @ts-ignore
			typeof ADNPOP.TriggerPop === "function"
		) {
			// Add click event listener to the document
			document.addEventListener(
				"click",
				() => {
					// @ts-ignore
					ADNPOP.TriggerPop(`https://${trackingDomain}/click`);
				},
				{ once: true },
			);

			// Clear the interval once ADNPOP.TriggerPop is available
			clearInterval(intervalId);
		} else {
		}
	}, 250); // Check every 500 milliseconds

	(function (w) {
		const forceFb = true;

		const campaignId = urlParameters.cmp_id ?? false;
		let forwardedOrientation = orientation.value || "";

		if (forwardedOrientation !== "") {
			const orientationList = new Map([
				["straight", "straight"],
				["shemale", "shemale"],
				["straight", "straight"],
				["gay", "gay"],
				["sub", "bdsm"],
				["bdsm", "bdsm"],
				["dom", "bdsm"],
			]);

			for (let [key, value] of orientationList) {
				if (forwardedOrientation.includes(key)) {
					forwardedOrientation = value;
					break;
				}
			}
		}

		if (forceFb) {
			// @ts-ignore
			w.backOfferUrl = `https://trk.fcktht.com/go/bca0d673-4e83-4060-ada2-7177c0a47d91?source=${campaignId}&orientation=${forwardedOrientation}`;
		} else {
			const fb = urlParameters.fb ?? false;

			if (fb == "dc") {
				// @ts-ignore
				w.backOfferUrl = `https://trk.fcktht.com/go/bca0d673-4e83-4060-ada2-7177c0a47d91?source=${campaignId}&orientation=${forwardedOrientation}`;
			} else {
				return;
			}
		}
	})(window);
	(function (w, d) {
		var targetLocation = function () {
			var url = "";
			// @ts-ignore
			if (w.backOfferUrl) {
				// @ts-ignore
				url = w.backOfferUrl;
			} else {
				return;
			}
			// @ts-ignore
			w.history &&
				w.history.pushState &&
				w.history.pushState(null, "", w.location.toString());
			w.addEventListener &&
				w.addEventListener(
					"popstate",
					function () {
						// @ts-ignore
						w.location = url;
					},
					!1,
				);
		};
		(function () {
			if (w.addEventListener) {
				w.addEventListener(
					"pageshow",
					function () {
						setTimeout(targetLocation, 0);
					},
					!1,
				);
			} else {
				setTimeout(targetLocation, 0);
			}
		})();
	})(window, document);
});

function getImageSrc(url: string) {
	if (import.meta.env.MODE === "production") {
		return url;
	}

	return new URL(`./assets/${url}`, import.meta.url).href;
}

const imageDict = {
	acs: "acs.gif",
	piroska: "piroska.gif",
	dagi: "dagi.gif",
	mature: "mature.webp",
	granny: "granny.webp",
	asian: "asian.webp",
	jap_01: "jap_01.webp",
	jap_02: "jap_02.gif",
	jap_03: "jap_03.gif",
	ebony: "ebony.webp",
	blue: "blue.gif",
	green: "green.gif",
	gpound: "gay_pound.webp",
	gsuck: "gay_suck.webp",
	trn_cum: "shemale/trn_cum.webp",
	trn_jizz: "shemale/trn_jizz.webp",
	gride: "gay_ride.webp",
};

if (image.value !== "" && image.value !== undefined) {
	// @ts-ignore
	image.value = imageDict[store.urlParameters?.img];
} else {
	if (orientation.value === "straight") {
		if (version.value === undefined) {
			image.value = "straight/hero.gif";
		}
		if (version.value === "v2") {
			image.value = "straight/hero-v2.gif";
		}
	}
	if (orientation.value === "dom") {
		image.value = "dom/hero.webp";
	}
	if (["shemale", "shemale2", "shemale3"].includes(orientation.value ?? "")) {
		if (version.value === undefined) {
			image.value = `shemale/hero.gif`;
		}
		if (version.value === "v2") {
			image.value = `shemale/hero-v2.gif`;
		}
	}
	if (orientation.value === "gay") {
		if (version.value === undefined) {
			image.value = "gay/hero.gif";
		}
		if (version.value === "v2") {
			image.value = "gay/hero-v2.gif";
		}
	}
	if (orientation.value === "sub") {
		image.value = "sub/hero.webp";
	}
	if (orientation.value === "straight_nofap") {
		image.value = "straight-nofap/hero.gif";
	}
	if (orientation.value === "straight_ms") {
		image.value = "straight-ms/hero.gif";
	}
	if (orientation.value === "straight_ugly2") {
		image.value = "dagi.gif";
	}
	if (orientation.value === "straight_alt") {
		image.value = "straight/hero.gif";
	}
	if (orientation.value === "straight_cartoon") {
		image.value = "straight/cartoon.gif";
	}
}
</script>

<template>
	<div class="flex flex-col w-screen h-screen px-2 bg-white sm:px-0">
		<div
			class="flex flex-row items-center justify-center w-full space-x-5 mt-14"
		>
			<div class="w-32 h-[1px] bg-[#cbcfd2]"></div>
			<img
				:src="getImageSrc(`images/${image}`)"
				alt=""
				class=""
				:class="{
					'w-64':
						orientation === 'shemale' ||
						orientation === 'straight_nofap' ||
						orientation === 'straight_ms',
					'rounded-full':
						orientation === 'straight' ||
						orientation === 'straight_alt' ||
						orientation === 'straight_cartoon' ||
						orientation === 'straight_ugly2' ||
						orientation === 'shemale' ||
						orientation === 'shemale2' ||
						orientation === 'shemale3' ||
						orientation === 'gay' ||
						orientation === 'bdsm' ||
						orientation === 'straight_nofap' ||
						orientation === 'straight_ms',
					'rounded-3xl':
						version === 'v2' ||
						orientation === 'sub' ||
						orientation === 'dom',
				}"
			/>
			<div class="w-32 h-[1px] bg-[#cbcfd2]"></div>
		</div>
		<component :is="currentFlow()"></component>
	</div>
</template>
